<template>
  <v-dialog
    v-model="internalDialog"
    max-width="480"
    :persistent="false"
    @click:outside="close"
  >
    <v-card>
      <v-card-title class="headline">
        Update Stage Dates
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isValid">
          <v-text-field
            :value="selectedStageName"
            label="Stage"
            outlined
            dense
            disabled
          />
          <date-picker
            v-model="localStartDate"
            :hide-details="false"
            :rules="[dateAtLeastOneRule]"
            :show-out-side-label="false"
            outlined
            label="Start Date"
            clearable
          />
          <date-picker
            v-model="localDueDate"
            :hide-details="false"
            :rules="[dateAtLeastOneRule]"
            :show-out-side-label="false"
            outlined
            clearable
            label="Due Date"
          />
          <v-textarea
            v-model="localNote"
            label="Note"
            rows="3"
            auto-grow
            outlined
            placeholder="Add a note"
            :rules="[v => !!v || 'กรุณาระบุโน๊ต']"
          />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="close">
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!localStageId || (!localStartDate && !localDueDate) || !localNote"
          @click="confirm"
        >
          Apply All
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue'

export default {
  name: 'UpdateStageDateDialog',

  components: {
    DatePicker
  },

  props: {
    value: {
      type: Boolean,
      required: true
    },
    stages: {
      type: Array,
      default: () => []
    },
    preSelectedStageId: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      localStageId: '',
      localStartDate: '',
      localDueDate: '',
      localNote: '',
      isValid: true
    }
  },

  computed: {
    internalDialog: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    selectedStageName () {
      const stage = this.stages.find((s) => s.id === this.localStageId)
      return stage ? stage.name : ''
    },
    dateAtLeastOneRule () {
      if (this.localStartDate || this.localDueDate) return true
      return 'กรุณาระบุ Start Date หรือ Due Date อย่างน้อย 1 รายการ'
    }
  },

  watch: {
    preSelectedStageId (val) {
      this.localStageId = val
    },
    internalDialog (val) {
      if (val) {
        this.localStageId = this.preSelectedStageId || ''
      } else {
        this.resetForm()
      }
    },
    localStartDate () {
      if (this.$refs.form) this.$refs.form.validate()
    },
    localDueDate () {
      if (this.$refs.form) this.$refs.form.validate()
    }
  },

  methods: {
    close () {
      this.$emit('close')
      this.internalDialog = false
    },

    confirm () {
      if (!this.$refs.form.validate()) return
      this.$emit('confirm', {
        stageId: this.localStageId,
        startDate: this.localStartDate,
        dueDate: this.localDueDate,
        note: this.localNote
      })
      this.close()
    },

    resetForm () {
      this.localStageId = ''
      this.localStartDate = ''
      this.localDueDate = ''
      this.localNote = ''
    }
  }
}
</script>
